/**
 * @generated SignedSource<<2d72345ff98d4dc88d721798b70838d8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MATOrganizationTeachersCreateDialog_matOrganization$data = {
  readonly id: string;
  readonly " $fragmentType": "MATOrganizationTeachersCreateDialog_matOrganization";
};
export type MATOrganizationTeachersCreateDialog_matOrganization$key = {
  readonly " $data"?: MATOrganizationTeachersCreateDialog_matOrganization$data;
  readonly " $fragmentSpreads": FragmentRefs<"MATOrganizationTeachersCreateDialog_matOrganization">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MATOrganizationTeachersCreateDialog_matOrganization",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "MATOrganization",
  "abstractKey": null
};

(node as any).hash = "96722a9bf6b97aeec6b6607d34a8fb54";

export default node;
